import { forwardRef, useEffect, useState } from 'react'
import {
    findFont,
    isMultiTouchProduct,
    makeFieldMultiTouch,
    selectTemplateField,
} from '../../helpers/slug'
import { classNames, log } from '../../helpers/utils'

const PreDefinedInput = forwardRef(
    (
        {
            item,
            getValues,
            defaultCustomizationTemplate,
            product,
            mailerKey,
            ...props
        },
        ref,
    ) => {
        let { label, name, setValue } = props
        name = name || label || item.name

        const [fontFamily, setFontFamily] = useState('')

        const selectTemplateValue = getValues(
            makeFieldMultiTouch(selectTemplateField.name, mailerKey),
        )

        const handleFont = (value) => {
            setFontFamily(findFont(value))
        }

        useEffect(() => {
            log('fontFamily', fontFamily)
        }, [fontFamily])

        useEffect(() => {
            if (setValue) {
                //console.log('item', item)
                const valueToSet =
                    defaultCustomizationTemplate?.[item.name] ||
                    item.defaultValue
                setValue(name, valueToSet)
                if (valueToSet) {
                    handleFont(valueToSet)
                }
            }
        }, [item, name, setValue])

        useEffect(() => {
            if (defaultCustomizationTemplate?.[item.name]) {
                setValue(name, defaultCustomizationTemplate?.[item.name])
                handleFont(defaultCustomizationTemplate?.[item.name])
            }
        }, [defaultCustomizationTemplate])

        if (!name) return null

        // if(item.type === 'textarea') return (
        //     <Textarea ref={ref} {...props} {...{item, getValues, defaultCustomizationTemplate}} />
        // )

        // log('defaultCustomizationTemplate', defaultCustomizationTemplate)

        //console.log('PreDefinedInput selectTemplateValue', selectTemplateValue)
        //console.log('PreDefinedInput defaultCustomizationTemplate', defaultCustomizationTemplate)
        if (isMultiTouchProduct(product) && !selectTemplateValue) {
            //console.log('return null')
            //return null
        }

        log('PreDefinedInput', selectTemplateValue)

        return (
            <div
                ref={ref}
                className="
                flex justify-between
                my-1
                bg-gray-50 relative w-full border border-gray-300 rounded-md pl-3 pr-5 py-2 text-left cursor-default focus:outline-none focus:ring-1 focus:ring-olh focus:border-olh sm:text-sm
                ">
                {item.type !== 'hidden' && (
                    <label className="block text-sm font-medium text-gray-700 pr-10">
                        {item?.label ?? item.name}
                    </label>
                )}

                <div
                    className={classNames(
                        fontFamily,
                        'sm:col-span-2 block text-sm font-medium text-olm-gray',
                    )}
                    key={item.defaultValue}>
                    {defaultCustomizationTemplate?.[item.name] ||
                        getValues(name) ||
                        item.defaultValue}
                </div>
            </div>
        )
    },
)

PreDefinedInput.displayName = 'PreDefinedInput'

export { PreDefinedInput }
